import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../Components/assets/icons/a1.png";
import colunms from "../../../Components/assets/icons/LINES.png";
import search1 from "../../../Components/assets/icons/search.png";
import top from "../../../Components/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faMoneyBill, fas, faWallet } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import toast, { Toaster } from "react-hot-toast";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import ModalDelete from "../../common/ModelDelete";
import ModelBulkUpload from "../../common/ModelBulkUpload";
import { AddButton, EditButton, DeletButton } from "../../common/Button";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import OffcanvasCon from "../../OffcanvasCon/OffcanvasCon";
import DataTable from "datatables.net";
import { formatDateToIST, IDS } from "../../../utils/common";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import Pagination from "react-bootstrap/Pagination";

library.add(fas);

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    Per_Page_Dropdown,
    postData,
    getDownloadDataExcel,
    isAllow,
    IMG_URL,
  } = useContext(Context);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);

  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();
  const [showoff, setShowoff] = useState(false);
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);

  const [search, setSearch] = useState("");
  const [searchStatus, setSearchStatus] = useState("");
  const [searchEmail, setsearchEmail] = useState("");
  const [searchNumber, setsearchNumber] = useState("");
  const [searchDate, setSearchDate] = useState("");
  const [searchDateTo, setSearchDateTo] = useState("");
  const getDataAll = async () => {
    const response = await getData(
      `/admin/subscription?page=${onPageChange}&per_page=${perPage}&term=${
        search || ""
      }&searchEmail=${searchEmail || ""}&searchNumber=${
        searchNumber || ""
      }&from=${searchDate || ""}&to=${searchDateTo || ""}&status=${searchStatus || ""}`
    );
    await setData(response);
    setCurrentPage(response?.data?.current_page);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);
    settotalPages(response?.data?.total_pages);

    setOption(await Per_Page_Dropdown(response?.data?.total));

    const newData = response?.data?.data;
    if (newData) {
      const newIds = newData.map((d) => d?.id);
      setAllChecked(newIds);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [changeStatus, perPage, reset, show, show1, onPageChange]);

  const [dataCount, setDataCount] = useState([]);
  const getDataAllCount = async () => {
    const response = await getData(`/admin/subscription/count`);
    await setDataCount(response);
    // setCurrentPage(response?.data?.current_page);
    // setperPage(response?.data?.per_page);
    // setSearch(response?.data?.search_name);
    // settotalPages(response?.data?.total_pages);

    // setOption(await Per_Page_Dropdown(response?.data?.total));

    // const newData = response?.data?.data;
    // if (newData) {
    //   const newIds = newData.map((d) => d?.id);
    //   setAllChecked(newIds);
    // }
  };

  useEffect(() => {
    getDataAllCount();
  }, []);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>
    );
  }

  const ChangeStatus = async (id) => {
    const response = await editStatusData(`/admin/subscription/${id}`);
    setChangeStatus(response);
  };

  // Modal function
  const handleClose = () => setShowAdd(false);
  const handleShow = () => setShowAdd(true);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  // Select All Functionality
  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value))
        );
      }
    }
  };

  // Delete module
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(
        `/admin/subscription/${recordToDeleteId}`
      );
      // notify("error", "Deleted Succefully");

      ErrorNotify(recordToDeleteName);

      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
      setChangeStatus(response);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  //  column hide and show.....
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
    col8: true,
    col9: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  useEffect(() => {
    const table = new DataTable("#example");
    return () => {
      table.destroy();
    };
  }, []);

  // const totalTrueStatus =
  //   data?.data?.data?.filter((item) => item.status === true)?.length || 0;
  return (
    <>
      <div className="main-advancedashboard ">
        <Header title={"Subscriptions"} link={"/admin/subscription"} />
        <section className="AdvanceDashboard">
          <div className="col-lg-12 p-0 Main-Section-Advanced-Dashboard">
            <div className="row MainRowsec me-0 ms-0">
              <section className="Tabels tab-radio tab-radio mt-3">
                <div className="">
                  {/* container */}
                  <div className="row">
                    <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                      <div className="add me-3">
                        {/* {isAllow.includes(IDS.Subscription.Add) ? (
                            <Link
                            
                              type="button"
                              className="btn btn-add pe-3"
                            >
                              <div onClick={() => handleShow()}>
                                <img
                                  src={plus}
                                  className="plus me-2 ms-0"
                                  alt=""
                                />
                                Add Plan
                              </div>
                            </Link>
                          ) : (
                            <></>
                          )} */}
                      </div>
                    </div>

                    <div className="border-line mt-3"></div>
                    <div className="row mt-4">
                      <div className=" col-12">
                        <div className="d-flex align-items-center mb-3">
                          <div className="show me-2">
                            <p className="show m-0">Show</p>
                          </div>
                          <div className="number me-2">
                            <select
                              className="form-select form-select-sm"
                              aria-label=".form-select-sm example"
                              onChange={(e) => {
                                setonPageChange(1);
                                setperPage(e.target.value);
                              }}
                            >
                              {option?.map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="entries">
                            <p className="show m-0">entries</p>
                          </div>
                          <div className="sowing ms-3 me-2">
                            <p className="show m-0">{`Showing ${Math.min(
                              (currentPage - 1) * perPage + 1
                            )} to ${Math.min(
                              currentPage * perPage,
                              data?.data?.total
                            )} of ${data?.data?.total} entries`}</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                        <div className="num">
                          <label className="form-label">Plan Name</label>
                          <input
                            type="text"
                            className="form-control"
                            id=""
                            value={search}
                            placeholder="Search Plan Name"
                            onChange={(e) => {
                              setSearch(e.target.value);
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                        <div className="num">
                          <label className="form-label">Email</label>
                          <input
                            type="text"
                            className="form-control"
                            id=""
                            value={searchEmail}
                            placeholder="Search Email"
                            onChange={(e) => {
                              setsearchEmail(e.target.value);
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                        <div className="num">
                          <label className="form-label">Contact Number</label>
                          <input
                            type="text"
                            className="form-control"
                            id=""
                            value={searchNumber}
                            placeholder="Contact Number"
                            onChange={(e) => {
                              setsearchNumber(e.target.value);
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                        <div className="num me-2">
                          <label className="form-label">
                            Purchase Start Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            placeholder="from"
                            value={searchDate}
                            onChange={(e) => {
                              setSearchDate(e.target.value);
                              setonPageChange(1);
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                        <div className="num me-2">
                          <label className="form-label">
                            Purchase End Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            placeholder="to"
                            value={searchDateTo}
                            onChange={(e) => {
                              setSearchDateTo(e.target.value);
                              setonPageChange(1);
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                        <div className="num">
                          <label className="form-label">Plan Status</label>
                          <select
                            className="form-control"
                            value={searchStatus}
                            onChange={(e) => setSearchStatus(e.target.value)}
                          >
                            <option value="">All</option>
                            <option value={1}>Active</option>
                            <option value={0}>Inactive</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2 d-flex gap-3 align-items-end">
                        <div className="Search me-2">
                          
                          <Button
                            type="button"
                            onClick={() => {
                              setonPageChange(1);

                              getDataAll();
                            }}
                            className="btn btn-search"
                          >
                            <img src={search1} className="search" alt="" />
                          </Button>
                        </div>
                        <div className="Search-1">
                          
                          <div>
                            <button
                              type="button"
                              onClick={() => {
                                setSearch("");
                                setsearchEmail("");
                                setsearchNumber("");
                                setSearchDate("");
                                setSearchDateTo("");
                                setSearchStatus('');
                                setReset(!reset);
                              }}
                              className="btn btn-reset"
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                      </div>
                      {/* <div className="   col-12">
                          <div className="row align-items-end">
                            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                              <div className="num">
                                <input
                                  type="text"
                                  className="form-control"
                                  id=""
                                  value={search}
                                  placeholder="Search Subscription"
                                  onChange={(e) => {
                                    setSearch(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2 d-flex gap-3 align-items-end">
                              <div className="Search me-2">
                                <Button
                                  type="button"
                                  onClick={() => { setonPageChange(1); getDataAll(); }}
                                  className="btn btn-search"
                                >
                                  <img
                                    src={search1}
                                    className="search"
                                    alt=""
                                  />
                                </Button>
                              </div>
                              <div className="Search-1">
                                <button
                                  type="button"
                                  onClick={() => {
                                    setSearch("");
                                    setReset(!reset);
                                  }}
                                  className="btn btn-reset"
                                >
                                  Reset
                                </button>
                              </div>
                            </div>
                          </div>
                        </div> */}
                    </div>
                  </div>


                  <div className="row mt-5">
                    <div className="col-xxl-3 col-xl-3 col-lg-4 col-sm-6 mb-3">
                      <div className="bucket-card-holder">
                        <div className="card-number-holder">
                          <div className="icon_holder">
                            <FontAwesomeIcon
                              className="inner_icon"
                              icon={faMoneyBill}
                            />

                            
                          </div>
  
                          <div className="text_holder">
                            <h3 className="count_text">
                              {dataCount?.data?.totalActiveCount}
                            </h3>
                            <h3 className="title_text">
                              Total Active Subscription:
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-xxl-3 col-xl-3 col-lg-4 col-sm-6 mb-3">
                      <div className="bucket-card-holder">
                        <div className="card-number-holder">
                          <div className="icon_holder">
                            <FontAwesomeIcon
                              className="inner_icon"
                              icon={faWallet}
                            />
                          </div>
  
                          <div className="text_holder">
                            <h3 className="count_text">
                              {dataCount?.data?.upcomingCount}
                            </h3>
                            <h3 className="title_text">
                              Total Upcoming Subscriptions
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div>
                    <strong>Total Active Subscription:</strong>{" "}
                    {dataCount?.data?.totalActiveCount}
                  </div>
                  <div>
                    <strong>Total Upcoming Subscriptions:</strong>{" "}
                    {dataCount?.data?.upcomingCount}
                  </div> */}

                  <div className="border-line mt-3"></div>
                  <div className="row mt-3">
                    <div className="data table-responsive">
                      <Table striped bordered hover responsive center>
                        <thead>
                          <tr className="">
                            {visible.col1 && (
                              <th className="sr" style={{ width: "10%" }}>
                                Sr. No.
                              </th>
                            )}
                            {visible.col2 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Users Name{" "}
                              </th>
                            )}{" "}
                            {visible.col3 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Email{" "}
                              </th>
                            )}
                            {visible.col3 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Contact No{" "}
                              </th>
                            )}
                            {visible.col4 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Plan{" "}
                              </th>
                            )}
                            {visible.col5 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Price
                              </th>
                            )}
                            {visible.col6 && (
                              <th className="active" style={{ width: "10%" }}>
                                Purchase Date
                              </th>
                            )}
                            {visible.col6 && (
                              <th className="active" style={{ width: "10%" }}>
                                Start Date
                              </th>
                            )}
                            {visible.col7 && (
                              <th className="active" style={{ width: "10%" }}>
                                Expiry Date
                              </th>
                            )}
                            {visible.col8 && (
                              <th className="active" style={{ width: "10%" }}>
                                Status
                              </th>
                            )}
                            {/* {visible.col9 && (
                                <th className="active" style={{ width: "10%" }}>Action</th>
                              )} */}
                          </tr>
                        </thead>
                        <tbody>
                          {data?.data?.data?.map((d, index) => {
                            const paginatedIndex =
                              (onPageChange - 1) * perPage + index + 1;
                            return (
                              <tr className="" key={index}>
                                {visible.col1 && <td>{paginatedIndex}.</td>}
                                {visible.col2 && <td>{d?.User?.name}</td>}{" "}
                                {visible.col3 && <td>{d?.User?.email}</td>}
                                {visible.col3 && <td>{d?.User?.contact_no}</td>}
                                {visible.col4 && (
                                  <td>
                                    {d?.Plan?.name} ({d?.plan_month} Month)
                                  </td>
                                )}
                               {visible.col5 && <td>₹ {d?.plan_price}</td>}

                                {visible.col6 && (
                                  <td>{formatDateToIST(d?.createdAt)}</td>
                                )}
                                {visible.col6 && (
                                  <td>{formatDateToIST(d?.start_date)}</td>
                                )}
                                {visible.col7 && (
                                  <td>{formatDateToIST(d?.expiry_date)}</td>
                                )}
                                {visible.col8 && (
                                  <td>
                                    <div className="form-check form-switch">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        checked={d.status}
                                        disabled={true}
                                        onChange={() => {
                                          ChangeStatus(d.id);
                                        }}
                                        id={`flexSwitchCheckDefault${d?.id}`}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={`flexSwitchCheckDefault${d?.id}`}
                                      >
                                        {d.status ? "Active" : "Inactive"}
                                      </label>
                                    </div>
                                  </td>
                                )}
                                {/* {visible.col9 && (
                                  <td>
                                    <div className="d-flex">
                                      {isAllow.includes(IDS.Plan.Edit) ? (
                                        <EditButton
                                          handleShow1={handleShow1}
                                          id={d?.id}
                                        />
                                      ) : (
                                        <></>
                                      )}
                                      {isAllow.includes(IDS.Plan.Delete) ? (
                                          <DeletButton
                                            showDeleteRecord={showDeleteRecord}
                                            id={d?.id}
                                            name={d?.name}
                                          />
                                        ) : (
                                          <></>
                                        )}
                                    </div>
                                  </td>
                                )} */}
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                      {data && data?.data?.data?.length > 0 ? (
                        <Pagination_Holder
                          onPageChange={currentPage}
                          totalPages={totalPages}
                          handlePageChange={handlePageChange}
                        />
                      ) : (
                        <p className="no-datashow">Sorry, No Data Found</p>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )}

      <ModalDelete
        show={showDeleteModal}
        handleDeleteRecord={handleDeleteRecord}
        handleDeleteCancel={handleDeleteCancel}
      />

      <ModelBulkUpload
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
      <Toaster position="top-right" />

      <OffcanvasCon show={showoff} handleClose={() => setShowoff(false)} />
    </>
  );
};

export default Tables;
